<script>
    import { _ } from "svelte-i18n";
    import { createEventDispatcher } from 'svelte';
    export let statuses = []
    export let statusShow = false;

    const dispatch = createEventDispatcher();

    function close()  {
        dispatch('close', {});
    }

</script>

{#if statusShow}
    <div class="popup fixed top-0 left-0 m-auto w-full h-full bg-stone-300/[.6] flex items-center justify-center flex-col">
        <div class="bg-white rounded-[5px] p-5 w-[400px] text-[14px] relative">              
            {#each statuses as status}
            <div class="text-right">
                <div>
                    {status.date}
                    {status.status}
                </div>
            </div>
            {/each}
            <div class="bg-red-500 text-white rounded-[5px] p-1 mt-1 cursor-pointer" on:click={()=>close()}>{$_('status.close')}</div>  
        </div>

    </div>
{/if}
